import type { TOC } from '@ember/component/template-only';
import { on } from '@ember/modifier';

import CommonUiIconComponent from 'webapp/components/common/ui-icon';

export interface Args {
	onSourceRequest: () => void;
}

const DataManagerGridItemPlaceholderRequestSourceTypeComponent: TOC<Args> = <template>
	<li
		role="button"
		class="card card--placeholder-request-source-type flex-item filter-all"
		{{on "click" @onSourceRequest}}
	>
		<div class="info">
			<CommonUiIconComponent @name="Plus" @size="lg" />
			<div class="title">Request new integration</div>
		</div>
	</li>
</template>;

export default DataManagerGridItemPlaceholderRequestSourceTypeComponent;
